import { render, staticRenderFns } from "./ShareMovementUpdateButtons.vue?vue&type=template&id=acedcfe0&"
import script from "./ShareMovementUpdateButtons.vue?vue&type=script&lang=js&"
export * from "./ShareMovementUpdateButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports